import React, { memo, useMemo } from "react";
import { useLocation } from "react-router-dom";
import logo from "../../assets/icons/scheduler360Logo.svg";
import socialrootsLogo from "../../assets/icons/socialrootsAI-logo.svg";

const HIDE_FOOTER_ROUTES = [
  "/login",
  "/register",
  "/forgot-password",
  "/verify-otp",
  "/change-password",
  "/questions",
  "/individual",
  "/logout",
  "/login-type",
];

const SCHEDULER_LOGO_SRC = logo;
const SOCIALROOTS_LOGO_SRC = socialrootsLogo;

const preloadImage = (src) => {
  const image = new Image();
  image.src = src;
};

preloadImage(SCHEDULER_LOGO_SRC);
preloadImage(SOCIALROOTS_LOGO_SRC);

const handleRedirect = () => {
  window.open(
    "https://www.socialroots.ai/",
    "_blank",
    "noopener,noreferrer"
  );
};

const FooterContent = memo(function FooterContent() {
  return (
    <footer className="mt-auto w-full bg-[#E4E4E4] py-2 text-white">
      <div className="flex w-full items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <span
          className="flex flex-shrink-0 cursor-pointer items-center transition-colors duration-200 hover:opacity-80"
          onClick={handleRedirect}
        >
          <img
            src={SCHEDULER_LOGO_SRC}
            alt="Scheduler Logo"
            decoding="async"
            className="h-[2.5rem] w-[8rem] object-contain sm:h-[3rem] sm:w-[10rem]"
          />
        </span>

        <div className="ml-auto flex flex-shrink-0 items-center gap-1">
          <span className="whitespace-nowrap text-xs text-black sm:text-sm">
            Powered by
          </span>
          <span
            className="flex cursor-pointer items-center transition-colors duration-200 hover:opacity-80"
            onClick={handleRedirect}
          >
            <img
              src={SOCIALROOTS_LOGO_SRC}
              alt="Socialroots AI logo"
              decoding="async"
              className="h-[2.5rem] w-[8rem] object-contain sm:h-[3rem] sm:w-[10rem]"
            />
          </span>
        </div>
      </div>
    </footer>
  );
});

const Footer = memo(function Footer() {
  const { pathname } = useLocation();

  const shouldHideFooter = useMemo(
    () => HIDE_FOOTER_ROUTES.some((route) => pathname.startsWith(route)),
    [pathname]
  );

  if (shouldHideFooter) {
    return null;
  }

  return <FooterContent />;
});

export default Footer;
 